import React from 'react'

import { formatJSON } from '../../utils'

export default function ActivityDuration({ item }) {
    let text = ''
    const obj = formatJSON(item)
    if (obj) {
        const { day = 0, hour = 0 } = obj
        const num = parseInt(parseInt(day * 24) + hour)
        text = `ABOUT ${num} HOUR`
    }

    return <>{text}</>
}
